<script>
    import VueDataTableFormBaseElement from "./VueDataTableFormBaseElement";

    export default {
        name: "VueDataTableFormBaseText",
        extends: VueDataTableFormBaseElement,
        data() {
            return {
                innerModel: this.model,
            }
        },
        watch: {
            model() {
                this.innerModel = this.model;
            }
        },
        created() {
            this.innerModel = this.model || "";
        },
    }
</script>